import { useCallback, useState } from 'react'

export const useOpen = (initialOpen?: boolean) => {
    const [isOpen, setOpen] = useState(!!initialOpen)
    const _handleOpen = useCallback(() => setOpen(true), [])
    const _handleClose = useCallback(() => setOpen(false), [])

    return { isOpen, onOpen: _handleOpen, onClose: _handleClose }
}
